export const state = () => ({
  allIdpsData: []
})
